<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="560px">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <a :href="item.path">
              <div class="pic_item">
                <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
                <span class="line"></span>
                <h3>{{item.title}}</h3>
                <p>{{item.detail}}</p>
              </div>
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      
      <div class="data">
        <div class="news">
          <div class="n_l"><span>新闻资讯：</span></div>
          <div class="n_c">
            <el-carousel height="50px" direction="vertical">
              <el-carousel-item v-for="item in ces" :key="item.name">
                <p class="medium"><a :href="item.path" target="_blank">{{ item.news }}</a></p>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="n_r"><a href="#/newsCenter" target="_blank">更多资讯</a></div>
        </div>
        <div class="share">
          <div style="height:45px;width:192px;margin:0 auto"><h2>大数据及效能</h2></div>
          <span></span>
        </div>
        <div class="data_card">
          <router-link to="/hadoop/beanstalk"  target="_blank">
            <div class="card" @click="toBeanstalk">
              <div class="box-card">
                <div class="img_1"></div>
                  <span></span>
              </div>
              <div class="text item" >
                <div class="text_content">
                  <p>Beanstalk企业研发管理平台</p>  
                  <span>Beanstalk企业研发管理平台是一站式<br>研发管理平台，它摒弃种类繁多的系统<br>带来的信息割裂...</span>  
                </div>               
                <div class="jiahao"><p style="font-size:30px">+</p></div>            
              </div>              
            </div>
          </router-link>
          <router-link to="/hadoop/bigdataPlatform" target="_blank">
            <div class="card">
              <div class="box-card">
                <div class="img_2"></div>
                <span></span>
              </div>
              <div class="text item">
                <div class="text_content">
                  <p>大数据平台</p>
                  <span>通过功存大数据测试工具的赋能，<br>客户在4个基本指标上都有显著的<br>提高。有效的提高了...</span>
                </div>
                <div class="jiahao"><p style="font-size:30px">+</p></div>
              </div>              
            </div>
          </router-link>
          <router-link to="/hadoop/agileManagement" target="_blank">
            <div class="card">
              <div class="box-card">
                <div class="img_3"></div>
                <span></span>
              </div>
              <div class="text item">
                <div class="text_content">
                  <p>敏捷管理咨询</p>
                  <span>数字化转型旨在借助数字世界里<br>强大的可连接、可汇聚和可推演的能力来<br>进行产品、业务和商业模式创...</span>
                </div>
                <div class="jiahao"><p style="font-size:30px">+</p></div>
              </div>
            </div>
          </router-link>
          <router-link to="/hadoop/qualityManagement" target="_blank">
            <div class="card">
              <div class="box-card">
                <div class="img_4"></div>
                <span></span>
              </div>
              <div class="text item">
                <div class="text_content">
                  <p>质量管理咨询</p>
                  <span>- TMMi咨询认证服务<br>- CMMI咨询认证服务<br>- 质量管理培训服务</span>
                </div>
              </div>
              <div class="jiahao"><p style="font-size:30px">+</p></div>
            </div>
          </router-link>
        </div>
      </div>

      <div class="city">
        <div class="share">
          <div style="height:45px;width:128px;margin:0 auto"><h2>城市大脑</h2></div>
          <span></span>
        </div>
        <div class="city_content">
          <div class="con_soc">
            <div class="con_icon" style="float:left"><img src="../../public/img/city_1.png" alt=""></div>
            <div class="con_word" style="margin-left:70px">
              <div class="word_tit">
                <div class="title"><p>社会态势解决方案</p></div>
                <span></span>
                <div class="detial">
                  <p>社会面态势感知研判系统通过综合运用云计算、物联网、大数据、人工智能等技术，打造“数据-智慧-能力”三位一体的新型指挥调度体系，实现指挥业务横向跨部门协同、纵向体系内贯通，根据省、市、区县...</p>
                </div>
                <a href="#/cityBrain/socialSolutions" target="_blank"><el-button type="primary" plain class="sub">查看详情</el-button></a>
              </div>
            </div>
          </div>
          <div class="con_imp">
            <div class="con_icon" style="width:122px"><img src="../../public/img/city_2.png" alt=""></div>
            <div class="con_word" style="margin-top:-300px;margin-left:112px">
              <div class="word_tit">
                <div class="title"><p>重点防护解决方案</p></div>
                <span></span>
                <div class="detial">
                  <p>运用三维建模技术，高精度、等比例还原重点目标和周边场景建筑三维模型，通过对重点区域出入口实时监控以及室内高精度定位，实现入侵告警、人流/车流趋势预判，重点人员关注等功能...</p>
                </div>
                <a href="#/cityBrain/importantSolutions" target="_blank"><el-button type="primary" plain class="sub">查看详情</el-button></a>
              </div>
            </div>
          </div>
          <span class="line_bg" style=""></span>
          <div class="con_war" style="height:287px">
            <div class="con_icon" style="margin-top:50px"><img src="../../public/img/city_3.png" alt=""></div>
            <div class="con_word" style="margin-top:-286px;margin-left:70px">
              <div class="word_tit">
                <div class="title"><p>警情中心解决方案</p></div>
                <span></span>
                <div class="detial">
                  <p>全量、全维度汇集警务活动有关的所有案事件信息。实现全量警情汇聚、出口精准分流、警务工作闭环等，为智慧政工考核提供数据支撑，最终实现警务全生命周期管理...</p>
                </div>
                <a href="#/cityBrain/warningSolutions" target="_blank"><el-button type="primary" plain class="sub">查看详情</el-button></a>
              </div>
            </div>
          </div>
          <div class="con_bia" style="height:287px">
            <div class="con_icon" style="width:122px;margin-top:50px"><img src="../../public/img/city_4.png" alt=""></div>
            <div class="con_word" style="margin-top:-286px;margin-left:112px">
              <div class="word_tit">
                <div class="title"><p>一标N实解决方案</p></div>
                <span></span>
                <div class="detial">
                  <p>一标N实系统，是在标准地址基础上，通过整合各类警务信息要素，结合移动便捷警务应用，实现警务一屏可见、警情一手掌握，提升警务工作效能，提高辖区整体平安保障能力...</p>
                </div>
                <a href="#/cityBrain/manySolutions" target="_blank"><el-button type="primary" plain class="sub">查看详情</el-button></a>
              </div>
            </div>
          </div>
        </div>
        
      </div>

      <div class="view">
        <div class="share">
        <div style="height:45px;width:96px;margin:0 auto"><h2>可视化</h2></div>
          <span></span>
        </div>
        <div class="view_content">
          <el-tabs v-model="activeName" @tab-click="handleClick" >
            <el-tab-pane label="产品" name="first">
              <div class="view_img"><img src="../../public/img/view1.png" alt=""> </div>
              <div class="view_word">
                <div class="title"><p>产品</p></div>
                <div class="detail">
                  <p>功存智能致力于打造功能强大、美观，使用简单的Web渲染引擎。与同类引擎相比，ZenloT.JS引擎体积更小、速度更快，延续了Web端性能体验优势，实现了真正的跨平台开发...</p> 
                </div>
                <div class="button">
                  <el-button type="primary" plain class="sub">WebGL引擎</el-button>
                  <el-button type="primary" plain class="sub">3D地图</el-button>                 
                </div>
                <div class="dianji"><a href="#/visual/product" target="_blank">查看详情</a> </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="开发平台" name="second">
              <div class="view_img"><img src="../../public/img/view2.png" alt=""> </div>
              <div class="view_word">
                <div class="title" style="width:122px"><p>开发平台</p></div>
                <div class="detail" style="height:84px">
                  <p>-一站式服务<br>-开发门槛低<br>-开发效率高...</p>
                </div>
                <div class="button">
                  <el-button type="primary" plain class="sub">一站式服务</el-button>
                  <el-button type="primary" plain class="sub">功能划分</el-button>
                </div>
                <div class="dianji"><a href="#/visual/developmentPlatform" target="_blank">查看详情</a> </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="可视化应用" name="third">
              <div class="view_img"><img src="../../public/img/view3.png" alt=""> </div>
              <div class="view_word">
                <div class="title" style="width:140px"><p>可视化应用</p></div>
                <div class="detail">
                  <p>只要有足够的创意和对行业的认知程度，任何公司都可以通过我们的可视化开发平台方便快捷的创造出超出用户预期的交付产品。同时我们也提供了深度定制服务，没有行业限制、没有...</p> 
                </div>
                <div class="button">
                  <el-button type="primary" plain class="sub">应用场景</el-button>
                  <el-button type="primary" plain class="sub">数字价值</el-button>
                </div>
                <div class="dianji"><a href="#/visual/apply" target="_blank">查看详情</a> </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="数字孪生应用" name="fourth">
              <div class="view_img"><img src="../../public/img/view4.png" alt=""> </div>
              <div class="view_word">
                <div class="title" style="width:168px"><p>数字孪生应用</p></div>
                <div class="detail">
                  <p>第一阶段：将物理对象变为数字化模型 。第二阶段：实时接收来自物理对象的数据，从而可以不断演化以保持与物理对象的一致。第三阶段：基于数字孪生可进行分析、预测、诊断、训练等...</p> 
                </div>
                <div class="button">
                  <el-button type="primary" plain class="sub">分析模型</el-button>
                  <el-button type="primary" plain class="sub">解决方案</el-button>
                </div>
                <div class="dianji"><a href="#/visual/digitalTwin" target="_blank">查看详情</a> </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="案例介绍" name="fifth">
              <div class="view_img"><img src="../../public/img/view1.png" alt=""> </div>
              <div class="view_word">
                <div class="title" style="width:112px"><p>案例介绍</p></div>
                <div class="detail">
                  <p>1.WebGL引擎视频</p><p> 2.某钢厂产线视频</p> 
                </div>
                <div class="button">
                  <el-button type="primary" plain class="sub">WebGL引擎</el-button>
                  <el-button type="primary" plain class="sub">钢厂产线</el-button>
                </div>
                <div class="dianji"><a href="#/visual/caseIntroduction" target="_blank">查看详情 </a> </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div class="important">
        <div class="share">
          <h2>重点客户</h2>
          <span></span>
        </div>
        <div class="imgs">
          <div class="box-card">
            <img src="../../public/img/c1.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c2.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c3.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c4.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c5.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c6.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c7.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c8.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c9.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c10.png" alt="">
          </div>
          <div class="box-card">
            <img src="../../public/img/c11.png" alt="">
          </div>
        </div>
      </div>
    </el-main>

    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>
<script>
import navmenu from '../components/navmenu.vue';
import footerMenu from '../components/footer.vue';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
	components: { navmenu,footerMenu },
  name: 'Home',
  /* components: {
    HelloWorld
  } */
  data() {
    return {
      imgList: [
        {
          name: "banner1",
          title:'助力企业数字化转型',
          detail:'构/建/更/具/前/瞻/性/业/务/模/式',
          src: require("../../public/bannerList/banner1.png"),
          path:'#/aboutus'
        },
        {
          name: "banner2",
          title:'Beanstalk',
          detail:'企/业/研/发/管/理/平/台/2.0/上/线',
          src: require("../../public/bannerList/banner2.png"),
          path:'#/hadoop/beanstalk'
        },
        {
          name: "banner3",
          title:'TMMi',
          detail:'官/方/认/证/评/估/服/务/供/应/商',
          src: require("../../public/bannerList/banner3.png"),
          path:'#/hadoop/qualityManagement?title=tmmi',
        },
        {
          name: "banner4",
          title:'CMMI',
          detail:'提/升/组/织/既/有/的/绩/效/改/进',
          src: require("../../public/bannerList/banner4.png"),
          path:'#/hadoop/qualityManagement?title=cmmi',
        },
      ],
      activeIndex: '1',
      activeName:'first',
      ces:[
        {
          name:'1',
          news:'<2021.04.08>喜讯 | 中标喜讯',
          path:'#/newsCenter/goodNews'
        },
        {
          name:'2',
          news:'<2020.12.13>活动丨功存智能携手老麦咖啡亮相2020敏捷之旅上海站',
          path:'#/newsCenter/honor'
        },
        {
          name:'3',
          news:'<2020.8.31>荣誉丨功存智能获得CMMI三级证书',
          path:'#/newsCenter/honor'
        },
      ]
    };
  },
  methods: {
    toBeanstalk(){
      this.$router.push({path:'/hadoop/beanstalk'})
    },
    handleClick(tab, event){
      // console.log(tab, event)
    },
      
    },
    

}
</script>
<style lang="scss" scoped>
@import '~@/assets/style/elementUi.scss'; 
@import '~@/assets/style/public.scss'; 
 a{
   color: #333;
   font-size: 18px;
 }
  .el-main{
    .pic_item {
      position: relative;
      height: 100%;
      h3{
        position: absolute;      
        left: 17%;
        top: 32%;
        font-size: 60px;
        font-family: PingFang SC;
        font-weight: 800;
        line-height: 100px;
        color: #FFFFFF;
        opacity: 1;
        animation:moveh3 3s infinite;
        @keyframes moveh3{
          from {left:19%;opacity: 0;}
          to {left:17%;opacity: 1;}
        }
        @-webkit-keyframes moveh3 /*Safari and Chrome*/{
          from {left:19%;opacity: 0;}
          to {left:17%;opacity: 1;}
        }
      }      
      p{
        position: absolute;
        left: 17%;
        top: 63%;        
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 100px;
        color: #FFFFFF;
        opacity: 1;
        animation:movep 3s infinite;
        @keyframes movep{
          from {top: 63%;opacity: 0;}
          to {top: 52%;opacity: 1;}
        }
        @-webkit-keyframes movep /*Safari and Chrome*/{
          from {top: 63%;opacity: 0;}
          to {top:52%;opacity: 1;}
        }
      }      
      .line{
        display: inline-block;
        width: 44px;
        height: 10px;
        position: absolute;
        left: 17%;
        top:40%;
        background: #fff;
        animation:movespan 3s infinite;
        @keyframes movespan{
          from {width: 0px;opacity: 0;}
          to {width: 44px;opacity: 1;}
        }
        @-webkit-keyframes movespan /*Safari and Chrome*/{
          from {width: 0px;opacity: 0;}
          to {width: 44px;opacity: 1;}
        }
      }
    }
    .pic_item:hover{
      cursor: pointer;
    }
    .share{
        padding:67.59px 0 60px 0;
        span{
          height: 3px;
          width: 44px;
          display: inline-block;
          background-color: #C5C5C5;
        }
      }
    .data{
      height: 888px;
      background-color: #F8F9FB;       
      margin-top:-16px; 
      .news{
        border-bottom:1px solid rgba(51, 51, 51, 0.15) ;
        padding-top:20px;
        height: 72px;
        width: 1200px;
        margin:0 auto;  
        text-align: center;
        line-height: 20px;
        .n_l{
          float: left;
          margin-top: 10px;
          /* width: 160px; */
          margin-left: -94px;
          text-indent: 60px;
          height: 55px;
          line-height: 55px;
          font-size: 18px;
          span{
            display: inline-block;
            width:180px;
            height: 55px;
            background: url(../../public/img/guangbo.png) 35px center no-repeat;
          }
        }
        .n_c{
          float:left;
          margin-top: 10px;
          width: 658px;
          height: 25px;
          text-align: left;
          a{
            color: #999;
            font-size: 18px;
            line-height: 20px;
          }
          /deep/ .el-carousel__indicators{
            z-index: -999 !important;
          }
        }
        .n_r{
          float: right;
          height: 30px;
          line-height: 20px;
          width: 120px;
          margin-top: 24px;
          color: #1E8DD4;
          background: url(../../public/img/jiao.png) 95px  8px no-repeat;
          a{
            color: #1E8DD4;
          }
        }
        .n_c,.n_r:hover{
          cursor: pointer;
        }
      }
      .data_card{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        .card{
          background: #fff;
          width: 292px;
          height: 480px;
          border-bottom: 2px solid #23C2E3 ;
          box-shadow: 5px 5px 15px #eee;
          .box-card{
            padding-top: 70px;
            span{
              height: 2px;
              width: 24px;
              margin: 0 auto;
              margin-top:-95px;
              display: inline-block;
              background-color: #1E8DD4;
            }
          }
          .img_1,.img_2,.img_3,.img_4{
            width: 68px;
            height: 68px;
            margin: 0 auto;           
          }
          .img_1{             
            background: url('../../public/img/shouye_1.png') center no-repeat;
          }
          .img_2{             
            background: url('../../public/img/shouye_2.png') center no-repeat;
          }
          .img_3{             
            background: url('../../public/img/shouye_3.png') center no-repeat;
          }
          .img_4{             
            background: url('../../public/img/shouye_4.png') center no-repeat;
          }      
          .text_content{
            height:119px ;
          }
          .jiahao{
            height: 143px;
            line-height: 143px;
          }
          .text{
            span{
              width: 252px;
              height: 76px;
              font-size: 14px;
              line-height: 28px;
              color: #FFFFFF;
              display: none;
            }
          }
        }
        .card:hover{
          background: linear-gradient(180deg, #23C2E3 0%, #1B9AEB 100%);
          border-bottom: none;
          color: #fff;
          cursor: pointer;
          .box-card{
            padding-top: 37px;
            span{
              background: #fff;
            }
          }
          .img_1 {
            background: url('../../public/img/sy_1.png') center no-repeat;
          }
          .img_2 {
            background: url('../../public/img/sy_2.png') center no-repeat;
          }
          .img_3 {
            background: url('../../public/img/sy_3.png') center no-repeat;
          }
          .img_4 {
            background: url('../../public/img/sy_4.png') center no-repeat;
          }
          .jiahao{
            margin-top: 65px !important;
            background: url('../../public/img/card_bg.png') center no-repeat;
          }
          .text{
            span{
              display: inline-block;
            }
          }
        }
      }
    }
    .city{
      height: 889px;
      .line_bg{
        display: inline-block;
        height:1px;
        width:223px;
        background:#eee;
        float: left;
        margin-left: 40.8%;
      }
      .city_content{
        width:1200px;
        height: 554px;  
        margin: 0 auto;
        
        div{
          height: 266px;
          width: 580px;
          .con_icon{
            width: 48px;
          }
          .word_tit{
            position: relative;
            span{
              width: 32px;
              height: 2px;
              display: inline-block;
              background: #1E8DD4;
              margin-left: -540px;
              margin-top: 24px;
            }
            .el-button--primary.is-plain{
              position: absolute;
              left: 0;
              /* margin-left: -83%; */
              border-color: #1E8DD4;
              color: #1E8DD4;
              background-color: #fff;
            }
            .el-button--primary.is-plain:hover{
              background-color: #1E8DD4 !important;
              color: #fff !important; 
            }
            .title{
              height:33px;
              width:192px;     
              margin-top: -33px;        
              p{               
                font-size: 24px;
                line-height: 40px;
                color: #333333;
              }
            }
            .detial{
              width: 480px;
              height: 84px;
              margin-bottom: 30px;
              p{                
                font-size: 14px;
                line-height: 32px;
                color: #999;
                text-align: left;
              }
            }
          }
        }
        .con_soc,.con_war{
          float: left;
          border-right: 1px solid #eee;
          padding-right: 20px;
        }
        .con_imp,.con_bia{
          float: right;
        }
      }
    }
    .view{
      height: 768px;
      background: #F8F9FB;
      .view_content{
        margin: 0 auto;
        width: 1200px;
        height: 530px;
        .view_img{
          height: 350px;
          float: left;
          margin-top: 70px;
        }
        .view_word{
          float: left;
          .title{
            height: 40px;
            width: 56px;
            margin-left: 64px;
            margin-top: 128px;
            p{             
              font-size: 28px;
              font-weight: 400;
              line-height: 20px;
            }
          }
          .detail{
            width: 491px;
            height:84px;
            margin-left: 64px;
            margin-top: 12px;           
            p{
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              line-height: 32px;
              color: #999999;
              text-align: left;
            }         
          }
          .button{
            float: left;
            margin-top: 32px;
            margin-left: 64px;
            .el-button{
              height: 30px;
              padding: 8px 10px;
              opacity: .6;
            }
            .el-button--primary.is-plain[data-v-fae5bece]{
              background-color: #F8F9FB;
              opacity: 0.6;
            }
            .el-button--primary.is-plain:hover{
              cursor: default;
              background-color: #F8F9FB;
            }
            
          }
          .dianji{
              margin-top:80px;
              margin-left: 52px;
              width:100px;
              height: 22px;
              background: url(../../public/img/jiao2.png) 88px 10px no-repeat ;
              a{
                font-size: 16px;
              }
            }
            .dianji:hover{
              a{color: #1E8DD4;}
              
            }
        }
      }
    }
    .important{
      height: 822px;      
      .imgs{
        width: 1200px;
        height:600px;
        margin: 0 auto;
        margin-top:-50px;
      }
      .box-card>img{
        width: 352px;
      }
      .imgs>div{
        margin-right: -8px;
        margin-left: -44px;
        margin-bottom: -67px;
        float: left;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Home.vue